import { Link } from "react-router-dom";
import { Button } from "../../components/ui/button";
import { Calendar, ArrowRight } from "lucide-react";

export default function Herosectionwidget() {
  return (
    <section className="relative bg-gradient-to-r from-primary/10 to-primary/5 py-20">
      <div className="container flex flex-col-reverse md:flex-row items-center gap-8">
        {/* Text Section */}
        <div className="flex-1 space-y-6 text-center md:text-left">
          <h1 className="text-4xl md:text-5xl font-bold leading-tight">
           From Newborns to Seniors <span className="text-primary">Complete Care Under One Roof</span>
          </h1>
          <p className="text-2xl font-semibold text-primary">
            @ TIMES HEALTH EXCELLENCE ICONS AWARDS 2025
          </p>
          <div className="flex flex-wrap justify-center md:justify-start gap-4">
            <Button size="lg" asChild>
              <Link to="/book-appointment">
                <Calendar className="mr-2 h-5 w-5" />
                Book an Appointment
              </Link>
            </Button>
            <Button size="lg" variant="outline" asChild>
              <Link to="/services">
                Our Services
                <ArrowRight className="ml-2 h-5 w-5" />
              </Link>
            </Button>
          </div>
        </div>

        {/* Image Section */}
        <div className="flex-1">
          <img
            src="/placeholder.svg?height=500&width=600&text=Pranaam+Hospitals+Awards"
            alt="Pranaam Hospitals Awards"
            width={600}
            height={500}
            className="rounded-lg shadow-xl"
          />
          <div className="absolute top-[60%] right-[25%]">
          <h1>600 × 600 px</h1>
        </div>
        </div>
        
      </div>
    </section>
  );
}
